export default {
  CLIENTS_LIST: "Liste des applications",
  ADD_CLIENT: "Ajouter une application",
  CLIENT_ADDED: "Application ajouté",
  CLIENTS_UPDATED: "Application modifié",
  EDIT_CLIENT: "Modifier cet application",
  DELETE_THIS_CLIENT: "Supprimer cet application?",
  CLIENT_DELETED: "Application supprimé",
  VIEW_CLIENT: "Application",
  NONE: "Aucune",
};
